/* ═══════════════════════════════════════════════════════════════
 * VWAP — Volume Weighted Average Price, dag-geankerd (UTC).
 * 1:1 poort van TERMINAL.indicators.computeVWAP uit
 * terminal_wyckoffpcg.html. Reset elke UTC-dag; berekend uit de
 * candles (typical price × volume).
 * ═══════════════════════════════════════════════════════════════ */

export function computeVWAP(candles) {
  const out = [];
  let day = null, pv = 0, vol = 0;
  for (const c of candles) {
    const d = Math.floor(c.time / 86400); // UTC-dag
    if (d !== day) { day = d; pv = 0; vol = 0; } // reset per sessie/dag
    const typ = (c.high + c.low + c.close) / 3;
    pv += typ * c.volume;
    vol += c.volume;
    out.push({ time: c.time, value: vol > 0 ? pv / vol : typ });
  }
  return out;
}
